<template>
    <div>
        <div class="row">
            <div class="column">
                <PageTitle title="E-mails en communicatie" :total="total + totalAdmin" :loading="loading" />
            </div>
        </div>

        <div class="row" v-if="user && user.role == 'pit'">
            <div class="column">
                <h4>Alleen zichtbaar voor PIT admins</h4>
            </div>
            <div class="column">
                <CommunicationTable
                    ref="CommunicationOverview_admins"
                    name="CommunicationOverview_admins"
                    tableType="admin"
                    :user="user"
                    :organisations="organisations"
                    @passTotal="passTotalAdmin"
                    @passLoading="passLoading"
                />
            </div>
        </div>

        <div class="row">
            <div class="column" v-if="user && user.role == 'pit'">
                <h4>Communicaties</h4>
            </div>
            <div class="column">
                <CommunicationTable
                    ref="CommunicationOverview"
                    name="CommunicationOverview"
                    :user="user"
                    :organisations="organisations"
                    @passTotal="passTotal"
                    @passLoading="passLoading"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CommunicationTable from './CommunicationTable'

export default {
    components: {
        CommunicationTable
    },


    data () {
        return {
            totalAdmin: null,
            total: null,
            loading: false
        }
    },

    computed: {
        user(){
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        }
    },

    mounted () {
        if(this.user && this.user.role == 'pit'){
            this.$refs['CommunicationOverview_admins'].load()
        }

        this.$refs['CommunicationOverview'].load()
    },

    methods: {
        passTotal(total){
            this.total = total
        },

        passTotalAdmin(total){
            this.totalAdmin = total
        },

        passLoading(loading) {
            this.loading = loading
        }
    }
}
</script>
